import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddClientAdAccountForm} from "./AddClientAdAccountForm";
import {ConfigureEventsStep} from "./ConfigureEventsStep";
import {withTranslation} from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {GOOGLE_CHANNEL, FACEBOOK_CHANNEL} from "../../channels/channels";

const STEP_LINK = 1;
const STEP_EVENTS = 2;

const CHANNELS_WITH_EVENTS_STEP = [GOOGLE_CHANNEL, FACEBOOK_CHANNEL];

class AddClientAdAccountModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            currentStep: STEP_LINK,
            createdAdAccountId: null,
            linkedChannel: null,
            adAccountDbId: null,
        };

        this.toggle = this.toggle.bind(this);
        this.afterStep1Submit = this.afterStep1Submit.bind(this);
        this.handleSaveEvents = this.handleSaveEvents.bind(this);
        this.handleSkipEvents = this.handleSkipEvents.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            currentStep: STEP_LINK,
            createdAdAccountId: null,
            linkedChannel: null,
            adAccountDbId: null,
        });
    }

    afterStep1Submit(newClientAdAccountId, channel, adAccountDbId) {
        if (CHANNELS_WITH_EVENTS_STEP.includes(channel)) {
            this.setState({
                currentStep: STEP_EVENTS,
                createdAdAccountId: newClientAdAccountId,
                linkedChannel: channel,
                adAccountDbId: adAccountDbId,
            });
        } else {
            this.toggle();
            this.props.afterSuccessfulSubmit(newClientAdAccountId);
        }
    }

    handleSaveEvents(selectedActions) {
        const url = `${API_URL}client/ad_account/${this.state.createdAdAccountId}/selected_actions`;
        new APIClient(url).call('POST', {selected_actions: selectedActions}).then((data) => {
            this.toggle();
            this.props.afterSuccessfulSubmit(this.state.createdAdAccountId);
        });
    }

    handleSkipEvents() {
        this.toggle();
        this.props.afterSuccessfulSubmit(this.state.createdAdAccountId);
    }

    renderStepIndicator() {
        const {t} = this.props;
        const {currentStep} = this.state;

        const step1Class = currentStep === STEP_LINK ? '-active' : '-completed';
        const step2Class = currentStep === STEP_EVENTS ? '-active' : '';

        return (
            <div className="link-account-steps">
                <div className={`link-account-step ${step1Class}`}>
                    <span className="step-circle">1</span>
                    <span className="step-label">{t('link_account_modal.step_link')}</span>
                </div>
                <div className="link-account-step-line"/>
                <div className={`link-account-step ${step2Class}`}>
                    <span className="step-circle">2</span>
                    <span className="step-label">{t('link_account_modal.step_events')}</span>
                </div>
            </div>
        );
    }

    renderHeaderTitle() {
        const {t} = this.props;
        const {currentStep} = this.state;

        if (currentStep === STEP_EVENTS) {
            return t('link_account_modal.title_step2');
        }
        return t('link_account_modal.title_step1');
    }

    shouldShowStepIndicator() {
        return true;
    }

    render() {
        const {currentStep} = this.state;

        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}>{this.renderHeaderTitle()}</ModalHeader>
                {this.shouldShowStepIndicator() && this.renderStepIndicator()}
                {currentStep === STEP_LINK &&
                    <AddClientAdAccountForm afterSuccessfulSubmit={this.afterStep1Submit}
                                            clientId={this.props.clientId}
                                            channel={this.props.channel}
                                            adAccountId={this.props.adAccountId}
                                            clientName={this.props.clientName}/>
                }
                {currentStep === STEP_EVENTS &&
                    <ConfigureEventsStep
                        channel={this.state.linkedChannel}
                        adAccountDbId={this.state.adAccountDbId}
                        agencyClientAdAccountId={this.state.createdAdAccountId}
                        onSave={this.handleSaveEvents}
                        onSkip={this.handleSkipEvents}/>
                }
            </Modal>
        );
    }
}

export const AddClientAdAccountModal = withTranslation()(AddClientAdAccountModalClass);
